export default __webpack_public_path__ + "static/media/downloadIcon.9c57bc76.svg";